import { Button, Flex, useToast } from '@chakra-ui/react';
import useToastError from 'hooks/shared/useToastError';
import FullScreenLoader from 'presentation/components/shared/FullScreenLoader';
import AlertModal from 'presentation/components/shared/modals/AlertModal';
import {
  ButtonSize,
  ButtonVariant,
} from 'presentation/theme/components/button';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useCancelOrderMutation } from 'rtkQuery/sharespro/queries/orders';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  orderId: ID;
}

const CancelOrderModal: FC<Props> = ({ onClose, isOpen, orderId }) => {
  const { t } = useTranslation();

  const [cancelOrder, { isLoading: isOrderCanceling }] =
    useCancelOrderMutation();

  const toast = useToast();
  const toastErrorHandler = useToastError();

  return (
    <>
      <AlertModal
        title={t('attention')}
        text={t('cancelOrderConfirmationText')}
        isOpen={isOpen}
        onClose={onClose}
        footer={
          <Flex>
            <Button
              variant={ButtonVariant.Ghost}
              mr={3}
              size={ButtonSize.sm}
              onClick={onClose}
            >
              {t('back')}
            </Button>
            <Button
              size={ButtonSize.sm}
              onClick={() => {
                cancelOrder(orderId)
                  .unwrap()
                  .then(() => {
                    toast({
                      description: t('orderCanceled'),
                      status: 'success',
                      position: 'top-right',
                      isClosable: true,
                    });
                    onClose();
                  })
                  .catch(toastErrorHandler);
              }}
            >
              {t('confirm')}
            </Button>
          </Flex>
        }
      />
      <FullScreenLoader isLoading={isOrderCanceling} />
    </>
  );
};

export default CancelOrderModal;
